import React, { useEffect } from "react";

import { useSelector } from "react-redux";
import { fullScreenHandler } from "../Helper";
import { getIcon } from "../../../helpers/icons";
import { formatDate } from "../../../helpers/date";
import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Editor from "../../../components/Editor";
import IconLabel from "../../../components/IconLabel";
import CategoryList from "../../../components/CategoryList";

import style from "./style.module.css";

export default function ArticleDetails({
    name = "",
    short_description = "",
    author_name = "",
    publish_date = "",
    themes = [],
    categories = [],
    tags = [],
    share = 0,
    setFullScreen,
    setPopup,
    fullScreen,
}) {

    const userProfile = useSelector((state) => state.storage.data);

    useEffect(() => {
        ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "msfullscreenchange"].forEach(
            eventType => document.addEventListener(eventType, fullscreenchanged, false)
        );
        return (() => {
            ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "msfullscreenchange"].forEach(
                eventType => document.removeEventListener(eventType, fullscreenchanged, false)
            );
        })
        // eslint-disable-next-line
    }, []);

    const fullscreenchanged = () => {
        setTimeout(() => {
            if (document.fullscreenElement) {
                setFullScreen(document.fullscreenElement ? true : false);
            }
            else if (document.webkitCurrentFullScreenElement) {
                setFullScreen(document.webkitCurrentFullScreenElement ? true : false);
            } else {
                setFullScreen(false);
            }
        }, 500);
    }

    useEffect(() => {
        let ele = document.getElementsByClassName(style.photoGallery);
        if (ele.length > 0) {
            fullScreenHandler(fullScreen, ele[0]);
        }
    }, [fullScreen]);
    
    return (
        <div className={style.articleDetails}>
            <div className={style.sectionHeader}>
                {
                    name !== "" && (
                        <Title transform="uppercase" tag="p" className="fontTeko">{name}</Title>
                    )
                }
                {
                    short_description !== "" && (
                        <Editor text={short_description} />
                    )
                }
                <div className={`${style.sectionSubHeader}`}>
                    {
                        author_name !== "" && author_name !== null && (
                            <IconLabel icon="User" label={author_name} />
                        )
                    }
                    {
                        publish_date !== "" && (
                            <IconLabel icon="Calendar" label={formatDate(publish_date)} />
                        )
                    }
                    {
                        themes.length > 0 && (
                            <CategoryList item={themes} tag="p" />
                        )
                    }
                    {
                        categories.length > 0 && (
                            <CategoryList item={categories} tag="p" />
                        )
                    }
                    {
                        tags.length > 0 && (
                            <CategoryList item={tags} tag="p" />
                        )
                    }
                </div>
            </div>
            <div className={style.sectionBody}>
                <div className={style.sectionSubFooter}>
                    <Link
                        onClick={() => { setPopup("share") }}
                    >
                        <i className={getIcon("Share")}></i> <span>Share</span>
                    </Link>
                    {
                        userProfile.id !== undefined && (
                            <Link
                                onClick={() => { setPopup("feedback") }}
                            >
                                <i className={getIcon("Feedback")}></i> <span>Feedback</span>
                            </Link>
                        )
                    }
                </div>
                <div className={style.sectionSubFooter}>
                    <Link onClick={() => setFullScreen(!fullScreen)}>
                        <i className={getIcon(fullScreen ? "Exitfullscreen" : "Fullscreen")}></i>
                    </Link>
                </div>
            </div>
        </div>
    )
}